import classes from "./CreatePassword.module.css"
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PrimaryButton from "../../Components/Buttons/PrimaryButton/PrimaryButton";
import Password from "../../Components/Password/Password";
import { createPassord } from "../../Store/actions/UsersActions";
import Input from "../../Components/Inputs/Input/Input";
import { useDispatch } from "react-redux";
import ConfirmationModal from "./ConfirmationModal/ConfirmationModal";
import { store } from "../../Store/Store";
import { warningActions } from "../../Store/Slices/WarningSlice";

const slide1 = "/Assets/Images/signUp1.svg"
const slide2 = "/Assets/Images/SignUp2.svg"
const slide3 = "/Assets/Images/SignUp3.svg"

export function CreatePassword({ props }) {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email'); 
  const dispatch = useDispatch()

  const [userDetails, setUserDetails] = useState({ userId: email || '' })
  const [confirmPassword, setConfirmPassword] = useState("")
  const [isPasswordValid, setIsPasswordValid] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false);

  const signInHandler = (e) => {
    // Handler logic if needed
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  const forgotPasswordHandler = (e) => {
    e.preventDefault()
    const data = { ...userDetails, userId: userDetails.userId.toLowerCase() }

    if (userDetails.password === "" || confirmPassword === "" || userDetails.password !== confirmPassword) {
      setIsPasswordValid(false);
      return;
    }
    createPassord(data, dispatch).then((response) => {
      if (response && response.data && response.data.success) {
        localStorage.setItem("isLoggedIn", "true");
        history.push(
          history.location?.state?.from || "/"
        );
      } else {
        store.dispatch(warningActions.showWarning({ message: "Wrong Email ID entered" }));
      }
    });
  }

  const slides = [
    {
      image: slide1,
      text: '"Cherish the Craftsmanship of Every Leather-Bound Edition."'
    },
    {
      image: slide2,
      text: '"Embrace the Timeless Elegance of Leather-Bound Treasures."'
    },
    {
      image: slide3,
      text: `"Elevate your book collection with us"`
    },
  ];

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const interval = setInterval(goToNextSlide, 2000);
    return () => clearInterval(interval);
  }, []);

  const isDisabled = () => {
    if (!userDetails.userId || !userDetails.password || !confirmPassword || userDetails.password !== confirmPassword) {
      return true;
    }
    return false;
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.Container}>
        <div className={classes.ForgotPasswordForm}>
          <h2>Create your new password</h2>
          <p>Enter your email below to generate your password</p>
          <form>
            <div className={classes.formGroup}>
              <Input
                type='email'
                id='userId'
                placeholder="Email"
                autoFocus={false}
                onChange={(e) => {}} // Empty function to prevent changes
                value={userDetails.userId}
                disabled={true} // Disable the input
              />
              
              <div className={classes.password}>
                <Password
                  id='password'
                  placeholder="Enter New Password"
                  togglePasswordVisibility={true}
                  height='2.25rem'
                  onChange={(e) =>
                    setUserDetails((prevState) => ({
                      ...prevState,
                      password: e.target.value,
                    }))
                  }
                  autoComplete='off'
                  onCommit={signInHandler}
                />
                {!isPasswordValid && (
                  <p style={{ color: "red", marginTop: "1rem", marginBottom: "0" }}>
                    Password is not valid
                  </p>
                )}
              </div>
              
              <div className={classes.password}>
                <Password
                  id='confirmPassword'
                  placeholder="Confirm New Password"
                  togglePasswordVisibility={true}
                  height='2.25rem'
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete='off'
                  onCommit={signInHandler}
                />
                {!isPasswordValid && (
                  <p style={{ color: "red", marginTop: "1rem", marginBottom: "0" }}>
                    Password is not valid
                  </p>
                )}
              </div>
            </div>

            <PrimaryButton
              onClick={(e) => forgotPasswordHandler(e)}
              disabled={isDisabled()}
              style={{
                width: "98%",
                height: "2.5rem",
                fontSize: "0.875rem",
              }}>
              Submit
            </PrimaryButton>
          </form>
        </div>
        <div className={classes.carouselContainer}>
          <div className={classes.carousel}>
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`${classes.slide} ${index === currentIndex ? classes.active : ''}`}
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <p className={index % 2 !== 0 ? classes.slideTextTop : ""}>{slide.text}</p>
              </div>
            ))}
          </div>
          <div className={classes.dots}>
            {slides.map((_, index) => (
              <span
                key={index}
                className={`${classes.dot} ${index === currentIndex ? classes.activeDot : ''}`}
                onClick={() => goToSlide(index)}
              ></span>
            ))}
          </div>
        </div>
      </div>

      {isModalOpen && <ConfirmationModal onClose={() => setIsModalOpen(false)} />}
    </div>
  );
}